<template>
  <div class="wrapper">
    <Alerts />
    <TheLoading />
    <TheHeader />
    <div>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </div>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "@/containers/TheHeader";
import TheFooter from "@/containers/TheFooter";
import Alerts from "@/components/Alerts";
import TheLoading from "@/components/TheLoading";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheFooter,
    Alerts,
    TheLoading,
  },
  metaInfo: {
    titleTemplate: process.env.VUE_APP_BASE_TITLE,
    meta: [
      { charset: "utf-8" },
      { name: "author", content: "پارسینا پردازان آریا | www.parsinaco.com" },
      {
        vmid: "description",
        name: "description",
        content:
          "اطلس پویا اراک تولید کننده پروفیل های آلومینیومی و لاین های نوری",
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "اطلس پویا اراک، تولید کننده لاین های نوری، لاین های نوری، اطلس، پویا، شرکت، رنگ الکترواستاتیک، استان مرکزی",
      },
    ],
  },
  beforeCreate() {
    this.$store.dispatch("baseX/getConfig");
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
